<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/classList'}">班课班级</el-breadcrumb-item>
      <el-breadcrumb-item>排课</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>课程信息</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData">
          <el-row :gutter="24">
            <!-- 选择课程 -->
            <el-col :span="12">
              <el-form-item label="选择课程" prop="courseId" class="course-form-item">
                <div class="course-select-wrapper">
                  <el-select
                    v-model="fromData.courseId"
                    @change="getTeacher(fromData.courseId)"
                    placeholder="请选择课程"
                    ref="courseSelect">
                    <el-option
                      v-for="item in courseList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="openCourseModal">
                    新建课程
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
            <!-- 班级名称 -->
            <el-col :span="12">
              <el-form-item label="班级名称" prop="className">
                <el-input v-model="fromData.className" placeholder="默认使用课程名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="容纳人数(人)" prop="maxNum">
                <el-input v-model="fromData.maxNum" placeholder="请输入容纳人数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单课时长(分钟)" prop="longTimeOf">
                <el-input v-model="fromData.longTimeOf" placeholder="单课时长为5的倍数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="扣除课次类型" prop="deductType">
                <el-select v-model="fromData.deductType" placeholder="请选择">
                  <el-option
                    v-for="item in deductTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="扣除课次数量" prop="deductTimes">
                <el-input-number v-model="fromData.deductTimes" :min="1" :max="3"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="授课老师" prop="teacherId">
                <el-select v-model="fromData.teacherId" placeholder="请选择">
                  <el-option
                    v-for="item in teacherList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上课教室" prop="classRoom">
                <el-input v-model="fromData.classRoom" placeholder="请输入上课教室"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <!-- 安排课表 -->
    <el-card class="mt20">
      <div slot="header" class="clearfix">
        <span>安排课表</span>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="单次排课" name="single">
          </el-tab-pane>
          <el-tab-pane label="循环排课" name="first">
          </el-tab-pane>
          <el-tab-pane v-if="false" label="日历排课" name="second">
          </el-tab-pane>
        </el-tabs>

        <!-- 单次排课表单 -->
        <el-form v-if="activeName == 'single'" label-width="160px" :rules="singleRules" ref="singleForm" :model="singleForm">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="开课日期" prop="startDates">
                <el-date-picker
                  v-model="singleForm.startDates"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" v-for="(time, index) in singleForm.classTimes" :key="time.key">
            <el-col :span="24">
              <el-form-item
                :label="'上课时间 ' + (index + 1)"
                :prop="`classTimes[${index}].beginTime`"
                :rules="{ required: true, message: '请选择开始时间', trigger: 'change' }">
                <el-time-picker
                  style="width: 120px;"
                  v-model="time.beginTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  @change="changeSingleEndTime(time, $event)"
                  placeholder="开始时间">
                </el-time-picker>
                至
                <el-time-picker
                  style="width: 120px;"
                  v-model="time.endTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  :prop="`classTimes[${index}].endTime`"
                  :rules="{ required: true, message: '请选择结束时间', trigger: 'change' }"
                  placeholder="结束时间">
                </el-time-picker>
                <el-button
                  v-if="singleForm.classTimes.length > 1"
                  @click="removeSingleTime(index)"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  style="margin-left: 10px;"
                  size="mini"></el-button>
                <el-button v-if="index == singleForm.classTimes.length -1" @click="addSingleTime" type="primary" icon="el-icon-plus" style="margin-left:5px;">添加时间段</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 循环排课表单 -->
        <el-form v-if="activeName == 'first'" label-width="160px" :rules="loopRules" ref="loopForm" :model="loopForm">
          <div v-for="(schedule, sIndex) in loopForm.schedules" :key="'loop-'+sIndex" class="schedule-item">
            <el-row :gutter="24" class="custom-flex-row">
              <el-col :span="8">
                <el-form-item label="开课日期" :prop="`schedules[${sIndex}].startDate`">
                  <el-date-picker
                    v-model="schedule.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="重复方式" :prop="`schedules[${sIndex}].loopType`">
                  <el-select v-model="schedule.loopType" placeholder="请选择">
                    <el-option
                      v-for="item in loopTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button v-if="loopForm.schedules.length > 1" @click="removeSchedule(sIndex, 'loop')"
                           type="danger" icon="el-icon-delete">
                  删除
                </el-button>
              </el-col>
              <el-col :span="5">
                <el-button @click="addNewSchedule('loop')" type="primary" icon="el-icon-plus">
                  添加开课日期
                </el-button>
              </el-col>
            </el-row>
            <div v-for="(time, tIndex) in schedule.timeSlots" :key="'loop-time-'+tIndex">
              <el-form-item
                :label="'上课时间 ' + (tIndex + 1)"
                :prop="`schedules[${sIndex}].timeSlots[${tIndex}].beginTime`">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <el-time-picker
                    v-model="time.beginTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    @change="changeEndTime(time, $event)"
                    style="width: 120px;"
                    placeholder="开始时间">
                  </el-time-picker>
                  <span style="flex-shrink: 0;">至</span>
                  <el-time-picker
                    v-model="time.endTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 120px;"
                    :prop="`schedules[${sIndex}].timeSlots[${tIndex}].endTime`"
                    placeholder="结束时间">
                  </el-time-picker>
                  <el-button
                    v-if="schedule.timeSlots.length > 1"
                    @click="removeTimeSlot(sIndex, tIndex, 'loop')"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    style="flex-shrink: 0;">
                  </el-button>
                  <el-button @click="addTimeSlot(sIndex, 'loop')" type="primary"
                             icon="el-icon-plus" size="small">添加时间段</el-button>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <!-- 日历排课表单 -->
        <el-form v-if="activeName == 'second'" label-width="160px" :rules="calendarRules" ref="calendarForm" :model="calendarForm">
          <div v-for="(schedule, sIndex) in calendarForm.schedules" :key="'calendar-'+sIndex" class="schedule-item">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="开课日期" :prop="`schedules[${sIndex}].startDate`">
                  <el-date-picker
                    v-model="schedule.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-button v-if="calendarForm.schedules.length > 1" @click="removeSchedule(sIndex, 'calendar')"
                           type="danger" icon="el-icon-delete" style="margin-top: 30px;">
                  删除
                </el-button>
              </el-col>
            </el-row>

            <div v-for="(time, tIndex) in schedule.timeSlots" :key="'calendar-time-'+tIndex">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="'上课时间 ' + (tIndex + 1)"
                    :prop="`schedules[${sIndex}].timeSlots[${tIndex}].beginTime`">
                    <el-time-picker
                      v-model="time.beginTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      @change="changeEndTime(time, $event)"
                      placeholder="开始时间">
                    </el-time-picker>
                    至
                    <el-time-picker
                      v-model="time.endTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      :prop="`schedules[${sIndex}].timeSlots[${tIndex}].endTime`"
                      placeholder="结束时间">
                    </el-time-picker>
                    <el-button v-if="schedule.timeSlots.length > 1"
                               @click="removeTimeSlot(sIndex, tIndex, 'calendar')"
                               type="danger" icon="el-icon-delete" circle
                               style="margin-left: 10px;" size="mini">
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <el-button @click="addTimeSlot(sIndex, 'calendar')" type="primary"
                       icon="el-icon-plus" size="small">
              添加时间段
            </el-button>

            <el-divider></el-divider>
          </div>

          <el-button @click="addNewSchedule('calendar')" type="primary" icon="el-icon-plus">
            添加开课日期
          </el-button>
        </el-form>
      </div>
    </el-card>

    <div class="footer-nav">
      <el-button type="primary" @click="submitForm()">确定</el-button>
      <el-button @click="resetForm()">取消</el-button>
    </div>

    <!-- 新建课程的弹窗 -->
    <el-dialog
      title="新建课程"
      :visible.sync="courseModalVisible"
      width="800px"
      :close-on-click-modal="false">
      <el-form label-width="160px" :rules="courseRules" ref="courseForm" :model="courseForm" class="course-form">
        <div>
          <h5 class="">基本信息</h5>
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择课程类型" prop="type">
              <div>
                <el-radio v-model="courseForm.type" :label="2" value="2">班课</el-radio>
              </div>
              <span class="wran_tips">(仅支持创建班课类型)</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程状态" prop="openStatus">
              <el-radio v-model="courseForm.openStatus" :label="1" value="1">开启</el-radio>
              <el-radio v-model="courseForm.openStatus" :label="0" value="0">关闭</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="课程名称" prop="name">
              <el-input placeholder="不超过50个字符" maxlength="50" v-model="courseForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单课时长" prop="longTimeOf">
              <el-input placeholder="单课时长为5的倍数" v-model="courseForm.longTimeOf" suffix="分钟">
                <template>
                  <slot slot="suffix" class="input-slot">分钟</slot>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="薪酬基数" label-position="top" prop="basicSalary">
              <el-input v-model="courseForm.basicSalary"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="累计增加基数" label-position="top" prop="addToSalary">
              <el-input v-model="courseForm.addToSalary"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="授课老师" prop="teacherId">
              <el-select v-model="courseForm.teacherId" placeholder="请选择">
                <el-option
                  v-for="item in teacherListAll"
                  :key="item.id"
                  :label="item.realname + '（' + item.phone + '）'"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程详情介绍" prop="description">
              <el-input type="textarea" v-model="courseForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="courseModalVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCourseForm" :loading="courseSubmitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id: '',
        fromData: {
          className: '',
          classRoom: '',
          courseId: '',
          longTimeOf: '',
          loopType: 2,
          deductType: 1,
          deductTimes: 1,
          maxNum: '',
          teacherId: '',
        },
        // 单次排课独立表单
        singleForm: {
          startDates: '',
          classTimes: [
            { beginTime: '', endTime: '', key: Date.now() }
          ]
        },
        // 循环排课独立表单
        loopForm: {
          schedules: [
            {
              startDate: '', // 开课日期
              loopType: 2,   // 重复方式（默认每周重复）
              timeSlots: [   // 时间段数组
                { beginTime: '08:30', endTime: '9:15' }
              ]
            }
          ]
        },
        // 日历排课独立表单
        calendarForm: {
          schedules: [
            {
              startDate: '', // 开课日期
              timeSlots: [   // 时间段数组
                { beginTime: '', endTime: '' }
              ]
            }
          ]
        },
        step: '00:45',
        activeName: 'first', // 默认选中循环排课
        loopTypeList: [
          { value: 1, label: '隔周重复' },
          { value: 2, label: '每周重复' },
          { value: 3, label: '隔日重复' },
          { value: 4, label: '每日重复' },
          { value: 5, label: '一三五重复' },
          { value: 6, label: '二四六重复' },
        ],
        allList: [],
        courseList: [],
        teacherList: [],
        deductTypeList: [
          { label: '次数', value: 1 },
          { label: '时长（小时）', value: 2 }
        ],
        // 基础信息校验规则
        rules: {
          className: [{ required: true, message: '请输入班级名称', trigger: 'blur' }],
          classRoom: [{ required: true, message: '请输入上课教室', trigger: 'blur' }],
          courseId: [{ required: true, message: '请选择所属课程', trigger: 'change' }],
          longTimeOf: [{ required: true, message: '请输入单课时长', trigger: 'blur' }],
          maxNum: [{ required: true, message: '请输入容纳人数', trigger: 'blur' }],
          teacherId: [{ required: true, message: '请选择授课老师', trigger: 'change' }],
        },
        // 单次排课校验规则
        singleRules: {
          startDates: [{ required: true, message: '请选择开课日期', trigger: 'change' }]
        },
        // 循环排课校验规则
        loopRules: {
          'schedules[0].startDate': [{ required: true, message: '请选择开课日期', trigger: 'change' }],
          'schedules[0].loopType': [{ required: true, message: '请选择重复方式', trigger: 'change' }],
          'schedules[0].timeSlots[0].beginTime': [{ required: true, message: '请选择开始时间', trigger: 'change' }]
        },
        // 日历排课校验规则
        calendarRules: {
          'schedules[0].startDate': [{ required: true, message: '请选择开课日期', trigger: 'change' }]
        },
        isEdit: false,

        // 新建课程弹窗相关数据
        courseModalVisible: false,
        courseSubmitting: false,
        courseForm: {
          type: 2,
          name: '',
          setMealId: '',
          longTimeOf: '',
          teacherId: '',
          basicSalary: '',
          addToSalary: '',
          description: '',
          openStatus: 1
        },
        courseRules: {
          type: [{ required: true, message: '请选择课程类型', trigger: 'blur' }],
          name: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
          teacherId: [{ required: true, message: '请选择授课老师', trigger: 'blur' }],
          longTimeOf: [{ required: true, message: '请输入单课时长', trigger: 'blur' }],
          openStatus: [{ required: true, message: '请选择课程状态', trigger: 'blur' }]
        },
        suitList: [],
        teacherListAll: []
      };
    },
    created() {
      this.initDate();
      this.getCourseList();
      this.getSetMealList();
      this.getTeacherListAll();
    },
    methods: {
      initDate() {
        let params = this.$route.params;
        if (params && params.type == 'edit') {
          this.fromData = params.recordDate
          this.fromData.teacherId = this.fromData.courseId
          this.isEdit = true;
        }
      },
      // 统一表单提交
      async submitForm() {
        try {
          // 校验基础信息
          const baseValid = await new Promise((resolve) => {
            this.$refs.fromData.validate((valid) => resolve(valid));
          });
          if (!baseValid) return;

          // 根据不同tab校验对应表单
          if (this.activeName === 'single') {
            const singleValid = await new Promise((resolve) => {
              this.$refs.singleForm.validate((valid) => resolve(valid));
            });
            if (!singleValid) return;
          } else if (this.activeName === 'first') {
            const loopValid = await new Promise((resolve) => {
              this.$refs.loopForm.validate((valid) => resolve(valid));
            });
            if (!loopValid) return;
          }

          // 构建提交数据
          const submitData = { ...this.fromData };
          if (this.activeName === 'single') {
            submitData.startDates = this.singleForm.startDates;
            submitData.timeStr = this.singleForm.classTimes
              .map(time => `${time.beginTime},${time.endTime}`)
              .join(';');
            submitData.type = 0;
          } else if (this.activeName === 'first') {
            submitData.timeStr = this.loopForm.schedules.map(schedule => {
              const times = schedule.timeSlots.map(time =>
                `${time.beginTime},${time.endTime}`).join(';');
              return `${schedule.startDate}|${schedule.loopType}|${times}`;
            }).join('#');
            submitData.type = 1;
          } else {
            submitData.timeStr = this.calendarForm.schedules.map(schedule => {
              const times = schedule.timeSlots.map(time =>
                `${time.beginTime},${time.endTime}`).join(';');
              return `${schedule.startDate}|${times}`;
            }).join('#');
            submitData.type = 2;
          }

          // 提交接口
          let url = this.isEdit ? '/ea/student/classClass/edit' : '/ea/student/classClass/add';
          const { data: res } = await this.$http.post(url, submitData);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.$message.success(this.isEdit ? '编辑成功' : "新增班级成功");
          this.$router.push({ path: '/classList' });
        } catch (e) {
          console.error("提交班级失败：", e);
          this.$message.error("操作失败，请重试");
        }
      },
      // 重置表单
      resetForm() {
        // 重置基础表单
        if (this.$refs.fromData) this.$refs.fromData.resetFields();
        // 重置各tab表单
        if (this.$refs.singleForm) this.$refs.singleForm.resetFields();
        if (this.$refs.loopForm) this.$refs.loopForm.resetFields();
        if (this.$refs.calendarForm) this.$refs.calendarForm.resetFields();
        // 重置数据
        this.singleForm.classTimes = [{ beginTime: '', endTime: '', key: Date.now() }];
        this.loopForm.schedules = [{
          startDate: '',
          loopType: 2,
          timeSlots: [{ beginTime: '08:30', endTime: '9:15' }]
        }];
        this.calendarForm.schedules = [{
          startDate: '',
          timeSlots: [{ beginTime: '', endTime: '' }]
        }];
        this.$router.push("/classList");
      },
      // tab切换
      handleClick(tab, event) {
        this.activeName = tab.name;
        if (tab.name == 'single') {
          this.fromData.type = 0;
        } else if (tab.name == 'first') {
          this.fromData.type = 1;
        }
      },
      // 添加单次排课时间段
      addSingleTime() {
        this.singleForm.classTimes.push({
          beginTime: '',
          endTime: '',
          key: Date.now() + this.singleForm.classTimes.length
        });
      },
      // 删除单次排课时间段
      removeSingleTime(index) {
        this.singleForm.classTimes.splice(index, 1);
      },
      // 修改单次排课结束时间
      changeSingleEndTime(timeItem, beginTime) {
        if (!beginTime || !this.fromData.longTimeOf) return;

        const [hours, minutes] = beginTime.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes + Number(this.fromData.longTimeOf);

        const endHours = Math.floor(totalMinutes / 60) % 24;
        const endMinutes = totalMinutes % 60;

        timeItem.endTime = `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;
      },
      // 修改循环/日历排课结束时间
      changeEndTime(timeItem, beginTime) {
        if (!beginTime || !this.fromData.longTimeOf) return;
        this.changeSingleEndTime(timeItem, beginTime);
      },
      // 添加新的开课日期配置
      addNewSchedule(type) {
        const newSchedule = {
          startDate: '',
          timeSlots: [{ beginTime: '', endTime: '' }]
        };
        if (type === 'loop') {
          newSchedule.loopType = 2;
          this.loopForm.schedules.push(newSchedule);
        } else if (type === 'calendar') {
          this.calendarForm.schedules.push(newSchedule);
        }
      },
      // 删除开课日期配置
      removeSchedule(index, type) {
        if (type === 'loop') {
          this.loopForm.schedules.splice(index, 1);
        } else if (type === 'calendar') {
          this.calendarForm.schedules.splice(index, 1);
        }
      },
      // 为特定开课日期添加时间段
      addTimeSlot(scheduleIndex, type) {
        const newTimeSlot = { beginTime: '', endTime: '' };
        if (type === 'loop') {
          this.loopForm.schedules[scheduleIndex].timeSlots.push(newTimeSlot);
        } else if (type === 'calendar') {
          this.calendarForm.schedules[scheduleIndex].timeSlots.push(newTimeSlot);
        }
      },
      // 删除特定时间段
      removeTimeSlot(scheduleIndex, timeIndex, type) {
        if (type === 'loop') {
          this.loopForm.schedules[scheduleIndex].timeSlots.splice(timeIndex, 1);
        } else if (type === 'calendar') {
          this.calendarForm.schedules[scheduleIndex].timeSlots.splice(timeIndex, 1);
        }
      },
      // 获取课程对应的老师列表
      getTeacher(id) {
        this.teacherList = [];
        if (!id) return;

        const currentCourse = this.allList.find(e => e.id == id);
        if (currentCourse) {
          this.teacherList.push({
            label: currentCourse.teacherName,
            value: currentCourse.id,
          });

          if (this.teacherList.length > 0 && !this.fromData.teacherId) {
            this.fromData.teacherId = this.teacherList[0].value;
          }

          if (!this.isEdit) {
            this.fromData.className = currentCourse.name;
          }
        }
      },
      // 获取所有课程信息（班课类型）
      async getCourseList() {
        try {
          const { data: res } = await this.$http.get(`/ea/student/course/getCourseList?type=2`);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.allList = res.result?.courses || [];
          this.courseList = [];
          this.allList.forEach(e => {
            this.courseList.push({
              value: e.id,
              label: e.name
            });
          });
          this.getTeacher(this.fromData.courseId);
        } catch (e) {
          console.error("获取课程列表失败：", e);
          this.$message.error("加载课程列表失败");
        }
      },
      // 打开新建课程弹窗
      openCourseModal() {
        this.courseForm = {
          type: 2,
          name: '',
          setMealId: '',
          longTimeOf: '',
          teacherId: '',
          basicSalary: '',
          addToSalary: '',
          description: '',
          openStatus: 1
        };
        this.$nextTick(() => {
          if (this.$refs.courseForm) {
            this.$refs.courseForm.resetFields();
          }
        });
        this.courseModalVisible = true;
      },
      // 获取套餐列表（新建课程用）
      async getSetMealList() {
        try {
          const { data: res } = await this.$http.get(`/ea/student/setMeal/getSetMealList`);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.suitList = res.result || [];
        } catch (e) {
          console.error("获取套餐列表失败：", e);
          this.$message.error("加载套餐列表失败");
        }
      },
      // 获取所有老师列表（新建课程用）
      async getTeacherListAll() {
        try {
          const { data: res } = await this.$http.get(`/ea/sys/user/getTeacherList`);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.teacherListAll = res.result || [];
        } catch (e) {
          console.error("获取老师列表失败：", e);
          this.$message.error("加载老师列表失败");
        }
      },
      // 提交新建课程表单
      async submitCourseForm() {
        if (this.courseSubmitting) return;
        this.courseSubmitting = true;

        try {
          const valid = await new Promise((resolve) => {
            this.$refs.courseForm.validate((valid) => resolve(valid));
          });

          if (!valid) {
            this.courseSubmitting = false;
            return;
          }

          const { data: res } = await this.$http.post("/ea/student/course/add", this.courseForm);

          if (res && res.code === 200) {
            this.$message.success("新增课程成功");
            this.courseModalVisible = false;
            await this.getCourseList();

            this.$nextTick(() => {
              const newCourseId = res.result?.id;
              if (newCourseId) {
                this.fromData.courseId = newCourseId;
                if (this.$refs.courseSelect) {
                  this.$refs.courseSelect.selectedValue = newCourseId;
                }

                const newCourse = this.allList.find(e => e.id == newCourseId);
                if (!this.isEdit) {
                  this.fromData.className = newCourse.name;
                }

                this.getTeacher(newCourseId);
              }
            });
          } else {
            this.$message.error(res?.message || "新增课程失败");
          }
        } catch (e) {
          console.error("新建课程异常：", e);
          this.$message.error("新增课程失败，请检查网络或联系管理员");
        } finally {
          this.courseSubmitting = false;
        }
      }
    },
  };
</script>

<style lang="less" scoped>
  .course-form-item {
    /deep/ .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }

  .course-select-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;

    .el-select {
      flex: 1;
    }

    .el-button {
      width: 80px;
      white-space: nowrap;
    }
  }

  .course-form {
    padding: 20px 0;

    .el-form-item {
      margin-bottom: 24px;
    }

    .el-col {
      padding: 0 8px;
    }
  }

  .wran_tips {
    color: red;
    font-size: 12px;
    margin-top: 4px;
    display: block;
  }

  .custom-flex-row {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-left: -12px;
    margin-right: -12px;

    .el-col {
      flex-shrink: 0;
    }
  }

  .schedule-item {
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 16px;

    &:last-child {
      border-bottom: none;
    }
  }

  .mt20 {
    margin-top: 20px;
  }

  /deep/ .el-upload__input {
    display: none;
  }
</style>
